import AddListModal from './modal/add_list';
import AddNewTaskComponent from './add_new_task';
import CreatedTaskComponent from './created_taks';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import { gray } from '../../theme/themePrimitives';
import LabelWrapper from '../wrapper/label';
import { Overlay } from '../prospecting';
import { settingAssignedTaskFlag } from '../../redux/slices/task';
import TaskItemDetailComponent from './task_item_detail';
import { useParams } from 'react-router';
import { Add, KeyboardArrowDown } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Menu, MenuItem, Typography } from '@mui/material';
import { fetchClientBoardDetails, fetchClientTaskThunk } from '../../redux/thunks/task';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const TasksComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [addTaskModal, setAddTaskModal] = useState<boolean>(false);
    // const [isCreated, setIsCreated] = useState<boolean>(false);
    const [anchorElForHeading, setAnchorElForHeading] = useState<null | HTMLElement>(null);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { isAddingTask, loaders, viewTaskItemDetail, isAssigned } = useSelector((state: RootState) => state.task);

    useEffect(() => {
        const fetchAllLists = async () => {
            try {
                if (currentUser?.role === 'client') {
                    // if (isAssigned) {
                    //     await dispatch(fetchAssignedTaskThunk()).unwrap();
                    // } else {
                    await dispatch(fetchClientBoardDetails(id ? parseInt(id as string, 10) : 0)).unwrap();
                    // }
                } else {
                    await dispatch(fetchClientTaskThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                }

                if (!isAssigned) {
                    await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                }
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllLists();
    }, [isAssigned, currentUser?.role]);

    const headingChangeHandler = (value: boolean) => {
        dispatch(settingAssignedTaskFlag(value));
        setAnchorElForHeading(null);
    };

    if (loaders.isLoading) {
        return (<Overlay>
            <CircularProgress size={24} />
            <Typography ml={2}>Loading...</Typography>
        </Overlay>);
    }

    if (viewTaskItemDetail) {
        return <TaskItemDetailComponent />;
    }

    if (isAddingTask) {
        return <AddNewTaskComponent />;
    }

    return (
        <Box borderTop={`1px solid ${gray[200]}`} py={2}>
            {currentUser?.role === 'client' && (
                <Box display="none">
                    <Button
                        variant="text"
                        color="secondary"
                        sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}
                        endIcon={<KeyboardArrowDown />}
                        onClick={(e) => setAnchorElForHeading(e.currentTarget)}
                    >
                        {isAssigned ? 'Assigned Tasks' : 'Created Tasks'}
                    </Button>
                    <Menu
                        anchorEl={anchorElForHeading}
                        open={Boolean(anchorElForHeading)}
                        onClose={() => setAnchorElForHeading(null)}
                        MenuListProps={{
                            'aria-labelledby': 'Heading-selection-button'
                        }}
                    >
                        {isAssigned && (
                            <MenuItem onClick={() => headingChangeHandler(false)}>Created Tasks</MenuItem>
                        )}
                        {!isAssigned && (
                            <MenuItem onClick={() => headingChangeHandler(true)}>Assigned Tasks</MenuItem>
                        )}
                    </Menu>
                </Box>
            )}

            <Box display="flex" alignItems="center" justifyContent="space-between">
                <LabelWrapper label="Manage tasks easily with our new Kanban view" />
                {/* || (currentUser?.role === 'client' && !isAssigned)) && ( */}
                {/* {(['organizationOwner', 'organizationAdmin', 'companyManager'].includes(currentUser?.role as string) && ( */}
                    <Button variant="contained" onClick={() => setAddTaskModal(true)}>
                        <Add /> Add New List
                    </Button>
                {/* ))} */}
            </Box>
            {
                // currentUser?.role === 'client' && isAssigned
                //     ? (<AssignedTaskComponent />) :
                (<CreatedTaskComponent />)
            }
            {addTaskModal && <AddListModal open={addTaskModal} onClose={() => setAddTaskModal(false)} />}
        </Box>
    );
};

export default TasksComponent;